// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__MpbPT","modal":"style_modal__nW5QW","container":"style_container__cNFG1","content":"style_content__+JJlH","form":"style_form__L7UVK"};